import React from "react";
import { presetAvatarUrl, firstName } from "../../lib/profile";

export default function ProfileAvatar({ user, size = 32, className = "", onClick }) {
  const src = user?.picture || presetAvatarUrl(user?.avatar_id || "hero");
  const ring = user?.accent || "var(--gc-primary, #0ea5e9)";
  const initial = (firstName(user) || "?").slice(0, 1).toUpperCase();
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      type={onClick ? "button" : undefined}
      onClick={onClick}
      title={user?.name || "Perfil"}
      className={"shrink-0 rounded-full overflow-hidden flex items-center justify-center " + className}
      style={{
        width: size,
        height: size,
        boxShadow: `0 0 0 2px ${ring}`,
        background: "var(--gc-bg-accent, #0f172a)",
      }}
    >
      {src ? (
        <img src={src} alt="" className="w-full h-full object-cover" style={{ imageRendering: user?.picture ? "auto" : "pixelated" }} />
      ) : (
        <span className="font-bold text-sky-500" style={{ fontSize: size * 0.4 }}>{initial}</span>
      )}
    </Comp>
  );
}
